import { reactive } from '../../js/reactive';
export const data = reactive.create({
    items: [],
    itemCount: 0,
    totalPrice: 0,
    totalOldPrice: 0
});
